<template>
  <div class="recipients" :class="{ disabled: disabled }">
    <span class="text" v-if="title">{{ title }}</span>
    <div class="input-wrap" :style="`width: ${width};`" @click.stop>
      <ul class="list" @click.stop="toggleTooltip">
        <li class="item-default" v-if="state.selected.length === 0">
          Добавить сотрудников, группы
        </li>
        <li class="item-tag" v-for="(item) in state.selected.slice().reverse()" :key="item.recipient_id">
          <div class="item-tag__text" v-if="isUserTag(item.recipient_id)">{{ item.profile.surname }} {{ item.profile.name }}</div>
          <div class="item-tag__text" v-else>{{ item.name }}</div>
          <div class="item-tag__remove" @click.stop="toggleCheckRecipient(item)">
            <svg width="10" height="10" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 1L12 12" stroke="currentColor" stroke-width="2"/>
              <path d="M1 12L12 1" stroke="currentColor" stroke-width="2"/>
            </svg>
          </div>
        </li>
      </ul>
      <transition name="fade">
        <div class="tooltip-wrap" v-show="isActive">
          <div class="tooltip">
            <div class="tooltip__header">
              <ul class="tab-list">
                <li v-for="tab in tabs"
                    :key="tab.id"
                    class="tab-list__item"
                    :class="tab.active ? 'active' : ''"
                    @click.stop="showTab(tab.name)">
                  {{ tab.title }}
                </li>
              </ul>
              <div class="tooltip__close" @click.stop="closeTooltip">
                <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 1L16 16" stroke="currentColor" stroke-width="2"/>
                  <path d="M1 16L16 1" stroke="currentColor" stroke-width="2"/>
                </svg>
              </div>
            </div>
            <div class="tooltip__body">
              <transition-group name="tabs-fade">
                <div v-show="tabs.users.active" :key="'users-tab'">
                  <div class="tooltip__tab-search">
                    <SearchForm :value="state.userSearch"
                                @form-submit="setUserSearch"/>
                  </div>
                  <ul class="option-list">
                    <li class="option-list__item"
                        v-for="(item, i) in state.tabs.users"
                        :key="i">
                      <div class="user-list__user-item" @click.stop="toggleCheckRecipient(item)">
                        <UserItem :name="item.profile.name"
                                  :surname="item.profile ? item.profile.surname : ''"
                                  :patronymic="item.profile.patronymic"
                                  :avatar="item.avatar"
                                  :positionId="item.position_id"
                                  :user="item"
                        />
                      </div>
                      <div class="user-list__checkbox">
                        <AppCheckbox :checked="item.is_checked"
                                     @toggle-check="toggleCheckRecipient(item)"
                        />
                      </div>
                    </li>
                  </ul>
                </div>
                <ul class="option-list" v-show="tabs.groups.active" :key="'groups-tab'">
                  <li class="option-list__item"
                      v-for="(item, i) in state.tabs.groups"
                      :key="i">
                    <div class="option-list__group-item" @click.stop="toggleCheckRecipient(item)">
                      <div class="user-avatar" :style="`background: ${item.color}; box-shadow: 0 0 0 2px ${item.color};`">
                        <svg width="21" height="15" viewBox="0 0 21 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M17.578 3.83416C17.578 5.27849 16.3678 6.44934 14.8749 6.44934C13.382 6.44934 12.1717 5.27849 12.1717 3.83416C12.1717 2.38984 13.382 1.21898 14.8749 1.21898C16.3678 1.21898 17.578 2.38984 17.578 3.83416ZM18.838 3.83416C18.838 5.3158 17.9694 6.60116 16.6978 7.23953C17.8624 7.59073 18.896 8.27178 19.6617 9.19962C20.3529 10.0372 20.793 11.0363 20.9427 12.0882H21V13.3072H12.1045C12.1404 13.4639 12.1697 13.622 12.1924 13.781H12.2497V14.5871V14.5901V15H0V14.5901V13.781H0.0573702C0.128603 13.2811 0.265722 12.7909 0.466228 12.3225C0.774031 11.6036 1.22519 10.9504 1.79393 10.4002C2.36268 9.84993 3.03788 9.41346 3.78098 9.11567C3.95197 9.04715 4.12578 8.98629 4.30187 8.93317C3.03027 8.29483 2.16151 7.00943 2.16151 5.52772C2.16151 3.41017 3.93587 1.69356 6.12466 1.69356C8.31345 1.69356 10.0878 3.41017 10.0878 5.52772C10.0878 7.00937 9.21913 8.29472 7.94761 8.9331C8.12379 8.98623 8.29768 9.04712 8.46876 9.11567C8.89639 9.28704 9.30154 9.50433 9.67685 9.76281C10.2865 8.81627 11.1628 8.05132 12.2088 7.56198C12.4826 7.43388 12.7645 7.32633 13.0521 7.23961C11.7805 6.60126 10.9117 5.31586 10.9117 3.83416C10.9117 1.71661 12.6861 0 14.8749 0C17.0637 0 18.838 1.71661 18.838 3.83416ZM11.677 12.0882H19.7133C19.5733 11.304 19.2309 10.5618 18.7121 9.93304C18.0176 9.09141 17.0481 8.50309 15.9625 8.26457C14.877 8.02604 13.7399 8.15147 12.7378 8.62028C11.8389 9.04079 11.0964 9.71518 10.6059 10.5506C11.0442 11.0057 11.4056 11.5246 11.677 12.0882ZM8.82782 5.52772C8.82782 6.97205 7.61758 8.1429 6.12466 8.1429C4.63175 8.1429 3.4215 6.97205 3.4215 5.52772C3.4215 4.0834 4.63175 2.91254 6.12466 2.91254C7.61758 2.91254 8.82782 4.0834 8.82782 5.52772ZM11.0426 13.781H1.20719C1.26962 13.4259 1.37311 13.0777 1.51629 12.7433C1.76697 12.1578 2.13441 11.6258 2.59761 11.1777C3.06082 10.7296 3.61072 10.3741 4.21593 10.1316C4.82114 9.88903 5.4698 9.7642 6.12487 9.7642C6.77994 9.7642 7.4286 9.88903 8.03381 10.1316C8.63902 10.3741 9.18892 10.7296 9.65213 11.1777C10.1153 11.6258 10.4828 12.1578 10.7335 12.7433C10.8766 13.0777 10.9801 13.4259 11.0426 13.781Z" fill="currentColor"/>
                        </svg>
                      </div>
                      <div class="option-list__group-item__name">
                        {{ item.name }}
                      </div>
                    </div>
                    <div class="user-list__checkbox">
                      <AppCheckbox :checked="item.is_checked"
                                   @toggle-check="toggleCheckRecipient(item)"
                      />
                    </div>
                  </li>
                </ul>
                <ul class="option-list" v-show="tabs.departments.active" :key="'departments-tab'">
                  <li class="option-list__item"
                      v-for="(item, i) in state.tabs.departments"
                      :key="i">
                    <div class="option-list__department-item" @click.stop="toggleCheckRecipient(item)">
                      {{ item.name }}
                    </div>
                    <div class="user-list__checkbox">
                      <AppCheckbox :checked="item.is_checked"
                                   @toggle-check="toggleCheckRecipient(item)"
                      />
                    </div>
                  </li>
                </ul>
              </transition-group>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import AppCheckbox from './AppCheckbox'
import UserItem from '../user/UserItem'
import SearchForm from '@/components/page/input/SearchForm'
import { mapGetters } from 'vuex'

export default {
  name: 'AppMessageRecipients',
  components: { SearchForm, UserItem, AppCheckbox },
  props: {
    title: String,
    isActive: Boolean,
    width: {
      type: String,
      default: '490px'
    },
    state: {
      type: Object,
      default: () => {}
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      tabs: {
        users: {
          id: 1,
          active: true,
          title: 'Сотрудники',
          name: 'users',
          options: []
        },
        groups: {
          id: 2,
          active: false,
          title: 'Группы',
          name: 'groups'
        },
        departments: {
          id: 3,
          active: false,
          title: 'Отделы',
          name: 'departments'
        }
      }
    }
  },
  computed: {
    ...mapGetters({ user: 'userForDetail' })
  },
  methods: {
    toggleTooltip () {
      this.$emit('toggle')
    },
    closeTooltip () {
      this.$emit('close')
    },
    showTab (tabName) {
      for (const key in this.tabs) {
        this.tabs[key].active = this.tabs[key].name === tabName
      }
    },
    toggleCheckRecipient (item) {
      this.$emit('toggle-check-recipient', item)
    },
    isUserTag (recipientId) {
      return recipientId.split('_').pop() === 'user'
    },
    setUserSearch (value) {
      this.$emit('setUserSearch', value)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/system/_vars';
@import '../../../assets/css/system/_mixins';

.recipients {
  display: flex;
  flex-flow: row nowrap;
  width: 100%;

  &.disabled {
    pointer-events: none;

    .list {
      border-color: $border_color;
      background: $color_deactive-bg;
    }
  }
}

.input-wrap {
  position: relative;
  z-index: 99;
}

.text {
  display: flex;
  align-items: center;
  color: $font_color_second;
  margin-right: 10px;
}

.list {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  height: 40px;
  border: 1px solid $font_color_second;
  border-radius: 3px;
  overflow: hidden;
  background-color: $color_main;
  padding: 6px;
  cursor: pointer;
  user-select: none;
}

.item-default {
  color: $font_color_second;
  margin-left: 14px;
  user-select: none;
}

.item-tag {
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  color: $font_color_alt;
  background: $color_second-light;
  border-radius: 3px;
  width: auto;
  max-width: 200px;
  padding: 6px 8px 6px 8px;
  margin-right: 6px;

  &__text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__remove {
    margin-left: 10px;
    transition: .3s;

    &:hover {
      opacity: .6;
    }
  }
}

.tooltip-wrap {
  position: absolute;
  top: -375px;
  left: 0;
}

.tooltip {
  position: relative;
  justify-content: space-between;
  height: 360px;
  background-color: $color_main;
  border: 1px solid $border_color;
  border-radius: 3px;
  box-shadow: 0 4px 4px rgba(17, 112, 184, 0.25);

  &__header {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    border-bottom: 3px solid $color_third;
  }

  &__close {
    color: #95A4C0;
    height: 100%;
    cursor: pointer;
    padding-right: 15px;
    padding-left: 15px;
    margin-left: auto;
    transition: .3s;

    &:hover {
      color: $color_second-light;
    }
  }

  &__body {
    margin: 10px 10px 14px 0;
    padding: 5px 0 0 30px;
    height: 280px;
    overflow: auto;

    &::-webkit-scrollbar {
      width: 8px;
    }

    &::-webkit-scrollbar-track {
      background: $border-color;
    }

    &::-webkit-scrollbar-thumb {
      background: $color_second-light;
    }
  }

  &__tab-search {
    width: 50%;
    margin-bottom: 20px;
  }

  &:before {
    content: '';
    display: block;
    position: absolute;
    top: auto;
    bottom: -6px;
    left: 25px;
    margin: 0 auto;
    width: 10px;
    height: 10px;
    background: linear-gradient(-45deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 50%, $color_main 50%, $color_main 100%);
    box-shadow: -4px -2px 3px rgba(17, 112, 184, 0.15);
    border: 1px solid $border_color;
    border-bottom: none;
    border-right: none;
    transform: rotate(-135deg);
  }
}

.tab-list {
  display: flex;
  flex-flow: row nowrap;
  padding: 20px 0 12px 35px;

  &__item {
    position: relative;
    color: $font_color_second;
    margin-right: 50px;
    cursor: pointer;
    transition: .3s;

    &.active {
      color: $color_second-light;

      &:before {
        display: block;
      }
    }

    &:before {
      display: none;
      content: '';
      position: absolute;
      top: auto;
      bottom: -15px;
      width: 100%;
      height: 3px;
      background: $color_second-light;
      animation: fadeIn .3s linear;
    }

    &:hover {
      color: $color_second-light;
    }

    &:last-child {
      margin-right: 0;
    }
  }
}

.option-list {
  display: flex;
  flex-flow: row wrap;
  width: 800px;

  &__item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 300px;
    margin-right: 100px;
    margin-bottom: 25px;
  }

  &__user-item {
    margin-right: 20px;
  }

  &__group-item {
    margin-right: 20px;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    cursor: pointer;

    &__name {
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow-y: hidden;
    }

    .user-avatar {
      @include size(35px);
      margin-right: 10px;
      color: $color_main;
    }
  }

  &__department-item {
    margin-right: 20px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow-y: hidden;
    cursor: pointer;
  }

  &__checkbox {
    margin-left: auto;
  }
}
</style>
